export class HistogrammeEcoulement {
    static jsonMap = {
        numMois: 'numMois',
        quantite: 'quantite',
        quantiteFrance: 'quantiteFrance',
        quantiteExport: 'quantiteExport',
        quantiteIndustrie: 'quantiteIndustrie',
        quantiteFreinte: 'quantiteFreinte'
    };

    numMois: number = undefined;
    quantite: number = undefined;
    quantiteFrance: number = undefined;
    quantiteExport: number = undefined;
    quantiteIndustrie: number = undefined;
    quantiteFreinte: number = undefined;
}
